import { Injectable, OnDestroy } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database-deprecated';
import { BehaviorSubject, Subscription } from 'rxjs';
import { AngularFirestore } from 'angularfire2/firestore';


@Injectable()
export class WeeklyPostsService implements OnDestroy {
    public user = new BehaviorSubject<any>({});
    public userId: string;
    private followers = [];
    private followUser = new BehaviorSubject<any>([]);
    subsc = new Subscription();
    constructor(private afs: AngularFirestore) {


    }
    weeklyPosts(hashtag, newpost) {
        this.afs.collection('weeklyPosts').ref.where('hashtagName', '==', hashtag).get().then((hash) => {
            if (!hash.empty) {
                if (hash.docs[0].data().hashtags[newpost.rating.uniqueName]) {

                    if (hash.docs[0].data().hashtags[newpost.rating.uniqueName].uniqueName === newpost.rating.uniqueName) {
                        let y = {};
                        y = hash.docs[0].data().hashtags;


                        let x = [];
                        x = hash.docs[0].data().hashtags[newpost.rating.uniqueName].modifyDate;
                        x.push(newpost.modifyDate);
                        let t = {
                            [newpost.rating.uniqueName]: {
                                modifyDate: x,
                                uniqueName: newpost.rating.uniqueName,
                                name: newpost.rating.name
                            }
                        }
                        t[newpost.rating.uniqueName]['total'] = t[newpost.rating.uniqueName].modifyDate.length;
                        Object.assign(y, t)


                        this.afs.collection('weeklyPosts').doc(hash.docs[0].id).update({
                            hashtags: y
                        })
                    }
                }
                else {
                    let y = {};
                    y = hash.docs[0].data().hashtags;
                    let v = {
                        [newpost.rating.uniqueName]: {
                            modifyDate: [newpost.modifyDate],
                            uniqueName: newpost.rating.uniqueName,
                            name: newpost.rating.name
                        }
                    }
                    v[newpost.rating.uniqueName]['total'] = v[newpost.rating.uniqueName].modifyDate.length;
                    // Object.defineProperty(v, 'total', {
                    //   value: v[this.rating.uniqueName].modifyDate.length
                    // })

                    Object.assign(y, v)
                    this.afs.collection('weeklyPosts').doc(hash.docs[0].id).update({
                        hashtags: y
                    })

                }
            }
        })



    }
    postCountDelete(userId, post) {
        console.log(userId);
        console.log(post);

        this.afs.collection('users').doc(userId).ref.get().then((data) => {
            if (!post.repostedByUser) {
                this.afs.collection('users').doc(userId).update({
                    myPosts: data.data().myPosts ? data.data().myPosts - 1 : 0
                })
            }
        }).then(() => {
            if (post.rating.type === 'brand') {
                this.afs.collection('brands').ref.where('uniqueName', '==', post.rating.uniqueName).get().then((data => {
                    if (!data.empty) {
                        this.afs.collection('brands').doc(data.docs[0].id).update({
                            myPosts: data.docs[0].data().myPosts ? data.docs[0].data().myPosts - 1 : 0
                        })
                    }

                }))

            }
            else if (post.rating.type === 'product') {
                this.afs.collection('products').ref.where('uniqueName', '==', post.rating.uniqueName).get().then((data => {
                    if (!data.empty) {
                        this.afs.collection('products').doc(data.docs[0].id).update({
                            myPosts: data.docs[0].data().myPosts ? data.docs[0].data().myPosts - 1 : 0
                        })
                    }

                }))

            }

        })


    }





    ngOnDestroy() {

    }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/_services/weeklyPosts.service.ts